import '@adornis/buchungsheld-components/authentication/bh-input-auth-code.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import '@adornis/chemistry/elements/components/x-hr.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import './bh-page-booked.js';
import { BHRegistrationFlowSubPage } from './bh-page-registration-sub-page.js';

@customElement('bh-page-registration-booked')
export class BHPageRegistrationBooked extends BHRegistrationFlowSubPage {
  override render() {
    // no error go to booked Page
    routingState.searchParams.set('__completed', 'true'); // mark flow as finished
    const params = routingState.getValue().searchParams.toString();
    goTo('/booked?' + params);
    // in case of embedd
    // TODO: unify this
    return html`<bh-page-booked .hideButton=${true}></bh-page-booked>`;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          height: '100%',
        },
      },
    ];
  }
}
